import { render, staticRenderFns } from "./ReminderDetails.vue?vue&type=template&id=0434f981&"
import script from "./ReminderDetails.vue?vue&type=script&lang=js&"
export * from "./ReminderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports